import { gql } from '@apollo/client'

export const CHANNEL_PUSH_MONITORING_QUERY = gql`
  query ChannelPushMonitoring($filters: ChannelPushMonitoringFilters!) {
    channelPushMonitoring(filters: $filters) {
      channelName
      channelId
      channelCode
      webHooks {
        adaptor
        state
        lastFetched {
          max {
            delay
            accName
            propertyCode
          }
          min {
            delay
            accName
            propertyCode
          }
        }
        lastSent {
          max {
            delay
            accName
            propertyCode
          }
          min {
            delay
            accName
            propertyCode
          }
        }
        healthStatus
        lastRequest
        lastResponse
      }
    }
  }
`
export const CHANNEL_PUSH_QUERY = gql`
  query ChannelPush($filters: ChannelPushFilters!) {
    channelPush(filters: $filters) {
      accommodations {
        propertyCode
        accommodationName
        pushs {
          adaptor
          lastFetched
          lastSent
          nextTime
          healthStatus
        }
      }
      webHooks {
        adaptor
        interval
        state
        lastAttempt
        failureCount
        endPoint
        subscribed
      }
    }
  }
`
export const ADD_NEW_WEBHOOK_MUTATIONS = gql`
  mutation AddNewWebHook($input: AddWebHookInput!) {
    addNewWebHook(input: $input) {
      message
    }
  }
`
export const UPDATE_WEBHOOK_MUTATIONS = gql`
  mutation UpdateWebHook($input: UpdateWebHookInput!) {
    updateWebHook(input: $input) {
      message
    }
  }
`
export const DELETE_WEBHOOK_MUTATIONS = gql`
  mutation DeleteWebHook($input: DeleteWebHookInput!) {
    deleteWebHook(input: $input) {
      message
    }
  }
`
